import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateParameter,
    getPageParameters,
    getParameterByUser,
} from '../ParameterEndPoint'

export const usePageParameters = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {parameterKeys} = QueryKeyManager(
        QueryKeyTypes.parameter,
        requestorId,
    )

    return useQuery({
        queryKey: parameterKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageParameters(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useParameterCRUD = (type, requestorId) => {
    const {parameterKeys} = QueryKeyManager(
        QueryKeyTypes.parameter,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateParameter(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Parameter Update Successfully !!',
                    )
                }
            }
        },
    })
}

export const useParameterByUser = (requestorId, userId, enabled = true) => {
    const {parameterKeys} = QueryKeyManager(
        QueryKeyTypes.parameter,
        requestorId,
    )
    return useQuery({
        queryKey: parameterKeys.detailByUser({userId}),
        queryFn: () => getParameterByUser(requestorId, userId),
        enabled: !!requestorId && !!userId && !!enabled,
    })
}
